'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    useToolbarGroupBase_unstable: function() {
        return useToolbarGroupBase_unstable;
    },
    useToolbarGroup_unstable: function() {
        return useToolbarGroup_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactutilities = require("@fluentui/react-utilities");
const _ToolbarContext = require("../Toolbar/ToolbarContext");
const useToolbarGroup_unstable = (props, ref)=>{
    return useToolbarGroupBase_unstable(props, ref);
};
const useToolbarGroupBase_unstable = (props, ref)=>{
    const vertical = (0, _ToolbarContext.useToolbarContext_unstable)((ctx)=>ctx.vertical);
    return {
        components: {
            root: 'div'
        },
        root: _reactutilities.slot.always((0, _reactutilities.getIntrinsicElementProps)('div', {
            ref,
            role: 'presentation',
            ...props
        }), {
            elementType: 'div'
        }),
        vertical
    };
};
